import React from 'react';
import { connect } from 'react-redux';
import { createActions } from '../../../store';
import ToggleButtonListItem from '../../../../../list-items/ToggleButtonListItem';
import CreatePageConstants from '../../../CreatePageConstants';

const anchorPointOptions = CreatePageConstants.ANCHOR_POINT_OPTIONS;

const TextAnchorListItem = (props) => {
    const { textElementAnchorPoint, index, updateTextElement } = props;
    const onAnchorChange = (value) => updateTextElement(index, { anchorPoint: value });
    
    return (
        <ToggleButtonListItem
            text='Anchor'
            value={textElementAnchorPoint}
            onChange={onAnchorChange}
            options={anchorPointOptions}
        />
    );
};

const mapStateToProps = (state, ownProps) => {
    const { anchorPoint: textElementAnchorPoint } = state.createPreview.present.videoSettings.text.textElements[ownProps.index];
    return { textElementAnchorPoint };
}

const mapDispatchToProps = (dispatch) => {
    const updateTextElement = (index, properties) => dispatch(createActions.updateTextElement(index, properties));
    return { updateTextElement }
}

export default connect(mapStateToProps, mapDispatchToProps)(TextAnchorListItem);